export class WorkflowStepAssignedView
{

    workflowStepId:number;
    workflowId:number;
    stepName:string;
    sequenceNumber:number;
    userSurveyRelId:number;
    stepStatus:string;
    wfStatus:string;
    userId:string;
    workflowStepUserSurveyId:number;
    itemIndex:number;
    initialtedByUserName:string;
    initiatedOn:Date;
    isAssigned:boolean=false;
    assignedToUser:string;
    stepStatusDescription:string;
    currentStatus:string;
    completedOn:Date;
    isOverdue: any;
}

export class WFStatusResult
{
    surveyId:string;
    workflowId:number;
    initialtedByUserName:string;
    initiatedOn:Date;
    isAssigned:boolean=false;
    wfStatus:string;
    wfStatusDescription:string;
    userSurveyRelId:number;
    step:WorkflowStepAssignedView[]=[];
    isExpanded:boolean=false;
    itemIndex:number;
}

